import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { StyledSearchResultLink } from "./SearchList.styled";
export var SearchItemTask = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a, linkHandler = props.linkHandler;
    return (_jsx(_Fragment, { children: data.map(function (item, index) {
            var link = "/tasks/".concat(item.id);
            return (_jsx(StyledSearchResultLink, { to: link, onClick: linkHandler, children: _jsx("div", { children: item.title }) }, "contact".concat(index)));
        }) }));
};
